<script>
    window.location.href = "https://azhoteis.com.br/entrar/"
</script>